<template>
  <div>
    <el-form ref="searchForm" :inline="true" class="searchBoxLine" :model="searchForm">
      <el-form-item label="项目名称:" clearable>
        <el-input v-model.trim="searchForm.reProjectName" placeholder="请输入项目名称" />
      </el-form-item>
      <el-form-item label="原合同编号:" clearable>
        <el-input v-model.trim="searchForm.reOldContractNum" placeholder="请输入原合同编号" />
      </el-form-item>
      <el-form-item label="合同编号:">
        <el-input v-model.trim="searchForm.reNewContractNum" placeholder="请输入合同编号" />
      </el-form-item>
      <el-form-item label="供货单位:">
        <el-input v-model.trim="searchForm.supplyCode" placeholder="请输入供货单位" />
      </el-form-item>
      <el-form-item label="订单时间:" prop="createBeginTime">
        <div class="rj-flex" style="width:260px;">
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.createBeginTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            />
          </div>
          <div style="display: inline-block;width: 10px;text-align: center">
            -
          </div>
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.createEndTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              :picker-options="pickerOptions"
            />
          </div>
        </div>
      </el-form-item>
      <el-form-item label="最终客户名称:" prop="rFinalCustomerName">
        <el-input v-model.trim="searchForm.rFinalCustomerName" placeholder="请输入最终客户名称" />
      </el-form-item>
      <el-form-item label="销售:">
        <el-input v-model.trim="searchForm.reSalesPersonName" placeholder="请输入销售名称" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="tableLoading" @click="searchCilck">
          搜索
        </el-button>
        <el-button type="default" @click="resetForm">
          重置
        </el-button>
      </el-form-item>
    </el-form>
    <div v-loading="tableLoading" class="tableBody">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="" label="操作" align="left" fixed="left" width="190">
          <template slot-scope="scope">
            <el-button v-if="approve(scope.row)" type="text" @click="handel(scope.row)">
              办理
            </el-button>
            <el-button v-if="sign(scope.row)" type="text" @click="contractSignature(scope.row)">
              签章
            </el-button>
            <el-button v-if="payment(scope.row)" type="text" @click="pay(scope.row)">
              付款
            </el-button>
            <el-button v-if="recall(scope.row)" type="text" @click="reCall(scope.row)">
              召回合同
            </el-button>
            <el-button v-if="final(scope.row)" type="text" @click="updateRed(scope.row)">
              上传红字信息表
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="rprojectName" label="项目名称" align="left" fixed="left" width="210">
          <template slot-scope="scope">
            <el-button type="text" class="el-btn-text-left" @click="check(scope.row)">
              {{ scope.row.rprojectName }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="roldContractNum" label="原合同编号" align="left" min-width="140px" />
        <el-table-column prop="rnewContractNum" label="退换货合同编号" align="left" width="150" />
        <el-table-column prop="rcontractType" label="合同类型" align="left" width="100" />
        <el-table-column prop="rorderAmount" label="退换货订单金额" align="right" header-align="left" width="150">
          <template slot-scope="{ row }">
            {{ row.rorderAmount && Number(row.rorderAmount).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column prop="rsalesPersonName" label="销售" align="left" width="150" />
        <el-table-column prop="rcreatedTime" label="合同时间" align="left" width="150" />
        <el-table-column prop="rcontractProcessStatus" label="合同状态" align="left" width="150">
          <template slot-scope="scope">
            {{ scope.row.rcontractStatus }}{{ scope.row.rcontractProcessStatus }}
          </template>
        </el-table-column>
        <el-table-column prop="deleteStatus" label="是否废弃" align="left" width="90" />
        <el-table-column prop="htfj" label="合同附件" align="left" fixed="right" width="150">
          <template slot-scope="scope">
            <el-button type="text" @click="htfj(scope.row)">
              合同附件
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: right;margin-top: 10px">
        <el-pagination
          :page-sizes="[10, 20, 30, 40]"
          :page-size.sync="page.pageSize"
          :current-page.sync="page.currentPage"
          layout="total, prev, pager, next, jumper,sizes"
          :total="page.total"
          @size-change="handerSizeChange"
          @current-change="handerCurrentChange"
        />
      </div>
    </div>
    <!-- <el-dialog title="合同附件" :visible.sync="DialogVisible" width="800px" :close-on-click-modal="false" :close-on-press-escape="false"> -->
    <!-- <contract-file :contract-id="num" :is-init="true" v-if="DialogVisible" :is-show="false" /> -->

    <el-dialog title="合同附件" :visible.sync="contractVisible" width="800px">
      <contract-attachment v-if="contractVisible" :contract-id="num" />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="contractVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- </el-dialog> -->
    <el-dialog title="红字信息表" :visible.sync="DialogRed" width="800px" :close-on-click-modal="false" :close-on-press-escape="false">
      <contract-file v-if="DialogRed" :contract-id="num" :is-init="true" :is-red="true" />
    </el-dialog>
  </div>
</template>
<script type="es6">
import contractFile from './commom/file.vue';
import contractAttachment from './commom/fileDialog.vue';
import { getListForAgent, reCall } from '../../../API/index';
export default {
  data () {
    return {
      searchForm: {
        createBeginTime: '',
        createEndTime: '',
        reProjectName: '',
        reOldContractNum: '',
        reNewContractNum: '',
        reSalesPersonName: ''
      },
      tableLoading: false,
      contractVisible: false,
      DialogRed: false,
      tableData: [
      ],
      num: '',
      page: {
        pageSize: 10,
        total: 100,
        currentPage: 1
      },
      pickerOptions: {
        disabledDate: (time) => {
          if (this.searchForm.strStartTime) {
            return time.getTime() <= (new Date(this.searchForm.strStartTime)).getTime();
          }
          return false;
        }
      }
    };
  },
  components: {
    contractFile,
    contractAttachment
  },
  computed: {

  },
  methods: {
    handerSizeChange (val) {
      // 改变每页条数 当前页回到第一页
      this.page.currentPage = 1;
      this.doSearch();
    },
    handerCurrentChange (val) {
      // 改变当前页
      this.doSearch();
    },
    doSearch () {
      this.tableLoading = true;
      getListForAgent({
        ...this.searchForm,
        pageIndex: this.page.currentPage,
        pageSize: this.page.pageSize
      }).then((res) => {
        this.tableLoading = false;
        let json = res.data;
        if (json.status === '200') {
          this.tableData = json.data.list;
          this.$set(this.tableData, 'removeVisible', false);
          this.page.currentPage = json.data.pageNum;
          this.page.total = json.data.total;
        }
      }).catch(() => {
        this.tableLoading = false;
      });
    },

    searchCilck () {
      this.page.currentPage = 1;
      this.doSearch();
    },

    resetForm () {
      this.$refs.searchForm.resetFields();
      this.searchForm = {};
      this.page.currentPage = 1;
      this.page.pageSize = 10;
      this.doSearch();
    },
    // 签章
    contractSignature (row) {
      this.$router.push({ 'name': 'chiefReturnbFile', query: { contractId: row.rcontractId } });
    },
    // 办理
    handel (row) {
      if (row.rcontractType === '换货合同' || row.rcontractType === '虚拟换货合同' || row.rcontractType === '价外费用合同') {
        this.$router.push({ name: 'chiefReturnbHandelChange', query: { roldContractNum: row.roldContractNum, rcontractType: row.rcontractType, rcontractId: row.rcontractId, rnewContractNum: row.rnewContractNum } });
      } else {
        this.$router.push({ name: 'chiefReturnbHandel', query: { rcontractType: row.rcontractType, rcontractId: row.rcontractId, contratType: row.rreasonType, rnewContractNum: row.rnewContractNum, roldContractNum: row.roldContractNum } });
      }
    },
    check (row) {
      // 真实退货合同 新增
      // if (row.rcontractType === '真实换货合同') {
      //   this.$router.push({ name: 'ContractInfo', params: { contractNum: row.contractNum }, query: { id: 11, masterProjectName: '123', isSon: false } });
      // } else if (row.rcontractType === '真实退货合同') {
      //   // 新页面 查看合同页面
      // this.$router.push({ name: 'checkHt', query: { rcontractType: row.rcontractType, rcontractId: row.rcontractId, action: false } });
      // }
      if (row.rcontractType === '换货合同' || row.rcontractType === '虚拟换货合同' || row.rcontractType === '价外费用合同') {
        this.$router.push({ name: 'checkHt', query: { rcontractType: row.rcontractType, rcontractId: row.rcontractId, number: row.rnewContractNum, action: false } });
      } else {
        this.$router.push({ name: 'checkHtChange', query: { rcontractType: row.rcontractType, rcontractId: row.rcontractId, number: row.rnewContractNum, action: false } });
      }
    },
    htfj (row) {
      // this.$router.push({ name: 'checkHt' });
      this.num = row.rcontractId;
      this.contractVisible = true;
    },
    pay (row) {
      this.$router.push({ name: 'chiefReturnbPay', query: { contractId: row.rcontractId, rnewContractNum: row.rnewContractNum, roldContractNum: row.roldContractNum, rcontractType: row.rcontractType } });
    },
    reCall (row) {
      let params = {
        contractId: row.rcontractId,
        contractNum: row.rnewContractNum,
        action: 'recall'
      };
      this.$confirm('是否召回合同？', '召回合同', {
        confirmButtonText: '召回',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        reCall(params).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.$message({
              type: 'success',
              message: '召回成功!'
            });
          }
          // refresh 列表
          this.doSearch();
        }).catch((res) => {

        });
      }).catch(() => {

      });
    },
    // 红字信息表
    updateRed (row) {
      this.num = row.rcontractId;
      this.DialogRed = true;
    },
    approve (row) {
      if (row.rcontractStatus === '待发布' || row.rcontractStatus.search('驳回') !== -1 || row.rcontractStatus.search('召回') !== -1) {
        return true;
      }
    },
    sign (row) {
      if (row.rcontractProcessStatus === '待盖章') {
        return true;
      }
    },
    payment (row) {
      if (row.rcontractProcessStatus === '待付款' && !['退货合同', '虚拟换货合同'].includes(row.rcontractType) && row.assignFlag) {
        return true;
      }
    },
    recall (row) {
      // 不包含这几项就显示
      if (!['待发布', '订单员已审批', '代理商召回,待发布'].includes(row.rcontractStatus)) {
        // 文本只要不包含财务驳回和订单员驳回 就显示
        if (row.rcontractStatus.indexOf('财务驳回') === -1 && row.rcontractStatus.indexOf('订单员驳回') === -1) {
          return true;
        }
      }
    },
    final (row) {
      if (row.rcontractType === '退货合同' && row.refundInvoiceType === 2 && row.rcontractStatus === '待财务审批') {
        return true;
      }
      return false;
    }
  },
  mounted () {
    this.doSearch();
  },
  activated () {

  },
  destroyed () {
  }
};
</script>
<style lang="scss"></style>
